<div [formGroup]="group" class="auth-content" id="wrapper">
    <mat-spinner></mat-spinner>
</div>